export enum PaginationDisplay {
  Dotted,
  Navigation,
}